import { OrganizationTab } from '~/app/components/organization/OrganizationTabList';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

type OrganizationTabsProps = {
  activeTab: string;
  onTabChange: (key: string) => void;
  tabList: OrganizationTab[];
};

export function OrganizationTabs({
  activeTab,
  onTabChange,
  tabList,
}: OrganizationTabsProps) {
  const { t } = useTranslation('organization');
  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={tabList.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
    />
  );
}
